<template>
  <div>
    <!-- Mobile & Tablet -->
    <mq-layout :mq="['mobile', 'tablet']">
      <div
        class="splashScreen"
        id="splashScreen-container"
        :style="{
          backgroundImage: `url(${splashUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }"
      >
        <img src="@/assets/splash-logo.png" class="splashScreen-logo" />
        <span class="splashScreen-title" v-if="toDisplay">
          <b>{{ title }}</b>
        </span>
        <span class="splashScreen-subtitle" v-if="toDisplay">{{
          $t('splashScreen.subtitle')
        }}</span>
        <div class="splashScreen-cta">
          <vv-splash-button custom-class="full-width no-shadow" @click="$router.push('/login')">
            <span>{{ $t('splashScreen.lets_go') }}</span>
          </vv-splash-button>
        </div>
      </div>
    </mq-layout>
    <mq-layout mq="desktop">
      <div
        class="header-shadow"
        id="splashScreen-container"
        :style="{ backgroundImage: 'url(' + splashUrl + ')' }"
      >
        <img src="@/assets/splash-logo.png" />
        <span class="splashScreen-title" v-if="toDisplay">
          <b>{{ title }}</b>
        </span>
        <span class="splashScreen-subtitle" v-if="toDisplay">{{
          $t('splashScreen.subtitle')
        }}</span>
        <div class="splashScreen-cta">
          <vv-splash-button @click="$router.push('/login')" class="white-variant">{{
            $t('splashScreen.lets_go')
          }}</vv-splash-button>
        </div>
      </div>
    </mq-layout>
  </div>
</template>
<script>
import remoteConfig from '@/lib/remote-config'
import { splash_screen_url } from '@/lib/remote-config/constants'
import VvSplashButton from '@/components/common/VvSplashButton'
export default {
  name: 'SplashScreen',
  components: { VvSplashButton },
  data: () => ({
    splashUrl: '',
    title: process.env.VUE_APP_TITLE
  }),
  computed: {
    toDisplay() {
      return ['vinovibes', 'domaine_dourbie', 'chateau_de_valcombe', 'vinoways'].includes(
        process.env.VUE_APP_APP_NAME
      )
    }
  },
  mounted() {
    this.splashUrl = remoteConfig.getString(splash_screen_url)
    if (process.env.VUE_APP_APP_NAME === 'domaine_dourbie') {
      this.splashUrl = require('@/assets/Dourbie-langudedoc-arbre.jpg')
    }
    sessionStorage.setItem('splashShown', '1')
  }
}
</script>
<style lang="scss">
@import '@/assets/styles/_variables.scss';

#splashScreen-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;

  img {
    height: auto;
    width: 200px;
    max-width: 240px;
  }
}
.header-shadow {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.splashScreen-title {
  margin-top: 20px;
  font-size: 32px;
  font-style: italic;
  color: white;
  text-align: center;
  font-family: 'STIXGeneral', Arial;
}
.splashScreen-subtitle {
  margin-top: 10px;
  font-family: $font-family-splash;
  font-size: 20px;
  color: white;
}
.splashScreen-cta {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
// Desktop
.Splash-Container-Desktop {
  position: absolute;
  top: 0; // Header size
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  width: 100%;
  height: calc(100vh);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    height: auto;
    width: 200px;
    max-width: 240px;
  }
  .Splash-Title {
    margin-top: 15px;
    font-size: 26px;
    font-weight: bold;
    margin: 50px 0;
  }
}
</style>
